import Pill from "@/src/common/components/pill";
import { FRAME_STATUS_LABELS, FRAME_STATUS_TONES } from "@/src/stories/constants/contact-copy";
import { FrameStatus, type FrameSummary } from "@/src/stories/utils/frame-state";

type ContactSummaryProps = {
	summary: FrameSummary;
};

const ContactSummary: React.FC<ContactSummaryProps> = ({ summary }) => (
	<div className="flex flex-col gap-3 rounded-xl border border-border-soft bg-surface p-4">
		<div className="flex flex-wrap items-center gap-2">
			<Pill tone={FRAME_STATUS_TONES[FrameStatus.GENERATED]}>{summary.generated} générées</Pill>
			<Pill tone={FRAME_STATUS_TONES[FrameStatus.INHERITED]}>{summary.inherited} héritées</Pill>
			<Pill tone={FRAME_STATUS_TONES[FrameStatus.PENDING]}>{summary.missing} en attente</Pill>
			<Pill tone={FRAME_STATUS_TONES[FrameStatus.FAILED]}>{summary.failed} échecs</Pill>
		</div>
		<div className="flex flex-col gap-1 text-muted text-xs">
			<span>
				<span className="font-semibold text-foreground">Entrée</span> = première image du plan ·{" "}
				<span className="font-semibold text-foreground">Sortie</span> = dernière image, requise uniquement pour les vidéos premium.
			</span>
			<span>
				<span className="font-semibold text-foreground">{FRAME_STATUS_LABELS[FrameStatus.INHERITED]}</span> : reprend la dernière image du
				plan précédent, aucune image à générer.{" "}
				<span className="font-semibold text-foreground">{FRAME_STATUS_LABELS[FrameStatus.NOT_REQUIRED]}</span> : pas d'image attendue pour
				ce plan.
			</span>
		</div>
	</div>
);

export default ContactSummary;
